import React from "react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getOrganizationBySubdomain } from "../../api/Helper";

interface AdminValidationProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

const AdminValidation: React.FC<AdminValidationProps> = ({
  children,
  fallbackPath = "/",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isAdminOrg, setIsAdminOrg] = React.useState<boolean | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const checkAdminOrg = async () => {
      const organizationName = await getOrganizationBySubdomain();
      const isAdmin = organizationName === "admin";
      setIsAdminOrg(isAdmin);
      setLoading(false);
    };

    checkAdminOrg();
  }, []);

  React.useEffect(() => {
    if (isAdminOrg === false) {
      navigate(fallbackPath, { replace: true });
    }
  }, [isAdminOrg, navigate, fallbackPath]);

  if (loading) {
    return (
      <div style={{ padding: "24px" }}>
        <Card>
          <div style={{ textAlign: "center", padding: "40px" }}>
            {t("Common-Loading")}
          </div>
        </Card>
      </div>
    );
  }

  if (isAdminOrg === false) return null;

  return <>{children}</>;
};

export default AdminValidation;
